import { render, staticRenderFns } from "./filtrosProcesamientos.vue?vue&type=template&id=0b50842e"
import script from "./filtrosProcesamientos.vue?vue&type=script&lang=js"
export * from "./filtrosProcesamientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports